<template>
  <div id="contact">
    <div class="mask"><img src="../../../static/images/footer-bg.png" alt=""></div>
    <div class="main">
      <div class="title">联系我们</div>
      <div class="form-box">
        <div class="top">
          <input type="text" placeholder="请留下您的联系方式" v-model="contact_way">
          <input type="text" placeholder="如何称呼您" v-model="username">
          <el-button type="primary" @click="sendMsg()">立即提交</el-button>
        </div>
        <div class="content">
          <el-input type="textarea" placeholder="填写您要提交的内容" v-model="content"></el-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  name: 'Contact',
  data() {
    return {
      contact_way: '',
      username: '',
      content: ''
    }
  },
  created() {

  },
  methods: {
    sendMsg() {
      let _this = this;
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/contact_us',
        data: {
          contact_way: _this.contact_way,
          username: _this.username,
          content: _this.content,
        }
      }).then((res) => {
        _this.open(res.data.data)
      })
    },
    open(str) {
        this.$alert(str, '提示', {
          confirmButtonText: '确定'
        });
      }
  },
  comments: {

  }
}
</script>
<style lang="stylus" scoped>
  #contact
    position relative
    width 100%
    height 450px
    background #000
    overflow hidden
    .mask
      position absolute
      left 0
      right 0
      top 0
      bottom 0
      &:before
        position absolute
        display block
        content ''
        width 100%
        height 100%
        background rgba(47,66,78,.85)
      img
        width 100%
        height 100%
    .main
      position relative
      width 974px
      margin 76px auto 53px auto
      background #efefef
      border-radius 10px
      overflow hidden
      .title
        width 100%
        height 80px
        line-height 100px
        padding-left 34px
        background #fff
        font-size 24px
      .form-box
        padding 30px 45px
        .top
          margin-bottom 25px
        input
          width 254px
          height 50px
          line-height 50px
          margin-right 30px
          padding-left 10px
          background none
          border 1px solid #d3d3d3
          border-radius 3px
        .el-button
          display inline-block
          width 208px
          height 50px
          line-height 50px
          margin-left 60px
          padding 0
          text-align center
          border-radius 0
</style>



// WEBPACK FOOTER //
// src/components/contact/contact.vue